import GlobalMethods from "@/lib/GlobalMethods"
import {fetchEntities, fromVuex} from "@/services/entity-loader";

const state = {
  state: true,
  module: "",
  organizationType: null,
  isMobile: false,
  echelonProvider: null

};

const getters = {
  getState: (state) => {
    return state.state
  },
  getIsMobile: (state) => {
    return state.isMobile
  },
  getModule: (state) => {
    return state.module
  },
  getOrganizationType: (state) => {
    let types = {
      Farm: 0,
      Elevator: 1,
      HeadOrganization: 2,
      Universal: 3,
    }
    return types[state.organizationType]
  },
  getOrganizationTypeNew: (state) => {
    return state.organizationType
  },
  getEchelonProvider: (state) => {
    return state.echelonProvider
  },
};

const mutations = {
  setState: (state, payload) => {
    state.state = payload
  },
  setIsMobile: (state, payload) => {
    state.isMobile = payload
  },
  setModule: (state, payload) => {
    state.module = payload
  },
  setOrganizationType: (state) => {
    state.organizationType = GlobalMethods.getOrganizationType()
  },
  setEchelonProvider: (state, payload) => {
    state.echelonProvider = payload ? payload.echelonProvider : false
  },
};

const actions = {
  actionSetState: ({commit}, payload) => {
    commit("setState", payload);
  },
  actionSetIsMobile: ({commit}, payload) => {
    commit("setIsMobile", payload);
  },
  actionSetModule: ({commit}, payload) => {
    commit("setModule", payload);
  },
  actionSetOrganizationType: ({commit}) => {
    commit("setOrganizationType");
  },
  actionSetEchelonProvider: ({commit}) => {
    if (state.echelonProvider === null) {
      fetchEntities(["organizationsgroup"], () => {
        commit("setEchelonProvider", fromVuex("organizationsgroup").find(o => o.id === GlobalMethods.getOrganization))
      })
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
